/**
 * Trainer prestige helper.
 *
 * A trainer's "prestige" is the rarity tier of their rarest owned Suikamon, surfaced
 * as a label + color. Shared by the trainer profile hero, the account/wallet menu, and
 * anywhere else that wants to show a trainer's rarity at a glance.
 */
import type { PetWithStatus } from '@shared/domain/petModels';

export const PRESTIGE_LABELS = ['Common', 'Rare', 'Epic', 'Legendary', 'Unique'] as const;

export const PRESTIGE_COLORS: Record<number, string> = {
  0: '#00e660',
  1: '#0070dd',
  2: '#a335ee',
  3: '#ff8000',
  4: '#e6cc80',
};

export interface Prestige {
  label: string;
  color: string;
}

/** Prestige derived from the rarest pet a trainer owns, or null when they own none. */
export function computePrestige(pets: PetWithStatus[]): Prestige | null {
  if (pets.length === 0) return null;
  const maxRarity = Math.max(...pets.map((p) => p.pet.rarity));
  return {
    label: PRESTIGE_LABELS[maxRarity] ?? PRESTIGE_LABELS[0],
    color: PRESTIGE_COLORS[maxRarity] ?? PRESTIGE_COLORS[0],
  };
}
